export class EmailTemplate {
    constructor() {
        this.id = null;
        this.tenantId = null;
        this.description = "";
        this.body = "";
        this.deleted = false;
        this.createdAt = new Date();
        this.updatedAt = new Date();
        this.userId = null;
    }
    get usableDescription() {
        if (this.description && /\S/.test(this.description)) {
            return this.description;
        }
        return "Untitled";
    }
    static sort(a, b) {
        return a.usableDescription
            .toLocaleLowerCase()
            .localeCompare(b.usableDescription.toLocaleLowerCase());
    }
    static clone(source) {
        var theClone = new EmailTemplate();
        theClone.tenantId = source.tenantId;
        theClone.description = source.description;
        theClone.body = source.body;
        theClone.deleted = source.deleted;
        theClone.createdAt = source.createdAt ? new Date(source.createdAt) : new Date();
        theClone.updatedAt = source.updatedAt ? new Date(source.updatedAt) : new Date();
        theClone.userId = source.userId || source.createdBy || null;
        theClone.id = source.id;
        return theClone;
    }
    static load(source) {
        return EmailTemplate.clone(source);
    }
    static makeBlank() {
        return new EmailTemplate();
    }
}
//# sourceMappingURL=email-template.js.map